import axios from "axios";

const BACKEND_URL = 'https://backend.theedutainmentbox.com';
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
  timeout: 12000,
});

export const submitStory = (payload) => api.post("/stories", payload).then((r) => r.data);
export const listStories = (limit = 12) =>
  api.get(`/stories?limit=${limit}`).then((r) => r.data);

export const notifyMe = (email) =>
  api.post("/notify", { email, source: "webscouts-tfx" }).then((r) => r.data);
export const notifyCount = () => api.get("/notify/count").then((r) => r.data);

export const submitScore = (game, player, score) =>
  api.post("/game-scores", { game, player, score }).then((r) => r.data);
export const listScores = (game, limit = 5) =>
  api.get(`/game-scores?game=${game}&limit=${limit}`).then((r) => r.data);

export const getAbout = () => api.get("/about").then((r) => r.data);
